import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a6fa1282")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "_header",
  ref: "header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "_img logo" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, "404 Not Found", -1)
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "grid smaller" }
const _hoisted_7 = { class: "billboard" }
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "_hero" }, "404", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "The page you're looking for could not be found!")
], -1)
const _hoisted_11 = { class: "grid" }
const _hoisted_12 = { class: "room" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Room = _resolveComponent("Room")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_IconButton, {
          text: "Host",
          colored: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        }),
        _createVNode(_component_IconButton, {
          text: "Join",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_IconButton, {
          icon: "forward",
          hex: "#FFFFFF",
          colored: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        })
      ])
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_IconButton, {
            text: "Host",
            colored: true,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({path:'/app'})))
          }),
          _createVNode(_component_IconButton, {
            text: "Join",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Room, {
          slowRotate: true,
          properties: _ctx.roomData,
          escaped: false
        }, null, 8, ["properties"])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}